import { useMemo } from 'react';
import { useAuthStore } from '../../store/authStore';
import { readLinked, writeLinked } from './outlineCache';
import { useLinkGraph } from '../../graph/useLinkGraph';
import { neighbors } from '../../graph/graphQueries';

/** Every relation but the structural `contains` (folder → page, page → sub-page). */
const LINK_RELATIONS = ['mentions', 'relates_to', 'covers', 'depends_on', 'documents', 'uses'];
const MAX_LINKED = 12;

/**
 * Boards, documents and other items this document is linked with (card 2.4,
 * "LINKED"): its graph neighbours — page links in either direction and the
 * explicit links made on the Graph page. Returns `{ items, index }`; open one
 * with graphNavigation.openGraphNode(item, index).
 */
export function useLinkedItems(documentId) {
  const { index, loading } = useLinkGraph();
  const userId = useAuthStore((s) => s.user?.id ?? null);
  const key = `${userId}:${documentId}`;
  return useMemo(() => {
    // While the graph is (re)building after a mount, show what the rail last
    // showed for this document instead of an empty list (owner, 14.10.2026:
    // no blink on tab switch / rail toggle).
    if (loading) return { items: readLinked(key) || [], index };
    const result = neighbors(index, `document:${documentId}`, { depth: 1, relations: LINK_RELATIONS, cap: MAX_LINKED + 1 });
    const items = (result?.nodes || []).filter((n) => n.id !== result.center).slice(0, MAX_LINKED);
    writeLinked(key, items);
    return { items, index };
  }, [index, loading, documentId, key]);
}
